<script lang="ts">
	//Design system components
	import { ControlsContainer } from '@Shelly/shelly-design-system/index';
	//Components
	import ControlOnOffAddon from 'src/components/Controls/Single/ControlOnOffAddon.svelte';
	import LoRaContainer from '../LoRaAddon/LoRaContainer.svelte';
	//Stores
		import { getDeviceStatus, getDeviceSettings, readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Types
	import type { Device } from 'src/types/Device';
	import type { ChartConfigInterface } from 'src/types/Chart';
	import { real_id } from 'src/helpers/interface_helpers';
	import SensorDeviceContainerV2 from './SensorAdvancedDeviceContainerV2.svelte';

	$: statusStore = getDeviceStatus(device.id);
	export let device: Device,
		deviceChartsConfig: ChartConfigInterface[],
		handleOnClickThumbChart: (e: CustomEvent | Event) => void,
		statuses;
</script>

{#if device.mode == 'lora'}
	<LoRaContainer {device} {statuses} />
{:else}
	<div class="flex-full-height justify-content-end">
		{#if device.mode == 'relay'}
			<ControlsContainer color={$showNewLayout ? 'color-0' : undefined}>
				<ControlOnOffAddon
					slot="first"
					class="align-self-center"
					status={$statusStore}
					component={device.component}
					{device}
					isWide
				/></ControlsContainer
			>
		{:else}
			<SensorDeviceContainerV2
				{device}
				{statuses}
				{deviceChartsConfig}
				{handleOnClickThumbChart}
			/>
		{/if}
	</div>
{/if}
